import * as React from 'react';

const SvgReferencesCompleted = props => {
  const { size, fill } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill={fill}
      {...props}
    >
      <g>
        <path d="M16.17 3.65h-3.79a1 1 0 100 2h3.79a1 1 0 000-2zM16.17 7.21h-3.79a1 1 0 000 2h3.79a1 1 0 000-2z" />
        <circle cx={6.9} cy={5.31} r={1.99} />
        <path d="M4 11.3a.46.46 0 01-.45-.53 3.42 3.42 0 016.76 0 .46.46 0 01-.45.53z" />
        <path d="M11.18 13.91H2.26a.27.27 0 01-.26-.27V2.26A.26.26 0 012.26 2H18.7a.27.27 0 01.27.26v7.32a7.5 7.5 0 012 .55V2.26A2.27 2.27 0 0018.7 0H2.26A2.27 2.27 0 000 2.26v11.38a2.27 2.27 0 002.26 2.27h8.32a7.47 7.47 0 01.6-2z" />
        <path d="M18 11a6 6 0 106 6 6 6 0 00-6-6zm3.27 4.71l-2.9 3.87a1.5 1.5 0 01-2.26.16l-1.5-1.5a.75.75 0 011.06-1.06l1.5 1.5 2.9-3.88a.75.75 0 111.2.91z" />
      </g>
    </svg>
  );
};

export default SvgReferencesCompleted;
